import ProminentCta from './ProminentCta'

export default ProminentCta
